(function () {
  'use strict';

  var T = window.theme || {};
  T.routes = T.routes || {};
  T.strings = T.strings || {};
  var R = {
    root: T.routes.root || '/',
    cart: T.routes.cart || '/cart',
    cartAdd: (T.routes.cartAdd || '/cart/add') + '.js',
    cartChange: (T.routes.cartChange || '/cart/change') + '.js',
    predictive: T.routes.predictiveSearch || '/search/suggest',
    recs: T.routes.recommendations || '/recommendations/products'
  };
  var rootUrl = R.root.replace(/\/$/, '');

  /* ─── UTILS ─── */
  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var n = (cents || 0) / 100;
    var hasDecimals = Math.round(n) !== n;
    var s = n.toLocaleString('nb-NO', { minimumFractionDigits: hasDecimals ? 2 : 0, maximumFractionDigits: 2 });
    var fmt = T.moneyFormat || '{{amount}} kr';
    if (/\{\{\s*\w+\s*\}\}/.test(fmt)) return fmt.replace(/\{\{\s*\w+\s*\}\}/, s).replace(/<[^>]*>/g, '');
    return s + ' kr';
  }
  function toast(msg) { var t = $('toast'); if (!t) return; t.textContent = msg; t.classList.add('show'); clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('show'); }, 3600); }
  function lockScroll(on) { document.body.style.overflow = on ? 'hidden' : ''; }
  var ALIASES = {};
  String(T.brandAliases || '').split(/\r?\n/).forEach(function (l) {
    var i = l.indexOf('='); if (i < 0) return;
    var k = l.slice(0, i).trim().toLowerCase(); if (k) ALIASES[k] = l.slice(i + 1).trim();
  });
  function brand(v) {
    v = String(v || '').trim();
    var k = v.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(ALIASES, k)) v = ALIASES[k];
    return v === T.shopName ? '' : v;
  }
  function imgSize(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ─── MOBILE NAV ─── */
  var burger = $('burger'), mobileNav = $('mobile-nav'), mobileOverlay = $('mobile-overlay'), mobileClose = $('mobile-nav-close');
  function openNav() { mobileNav && mobileNav.classList.add('open'); mobileOverlay && mobileOverlay.classList.add('open'); lockScroll(true); }
  function closeNav() { mobileNav && mobileNav.classList.remove('open'); mobileOverlay && mobileOverlay.classList.remove('open'); lockScroll(false); }
  if (burger) burger.addEventListener('click', openNav);
  if (mobileClose) mobileClose.addEventListener('click', closeNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeNav);

  /* ─── SEARCH + PREDICTIVE SEARCH ─── */
  var searchOpen = $('search-open'), searchModal = $('search-modal'), searchClose = $('search-close');
  var searchField = $('search-field'), psResults = $('ps-results'), psTimer, psCtrl;
  function openSearch() { if (!searchModal) return; searchModal.classList.add('open'); setTimeout(function () { if (searchField) searchField.focus(); }, 80); }
  function closeSearch() { searchModal && searchModal.classList.remove('open'); }
  if (searchOpen) searchOpen.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchModal) searchModal.addEventListener('click', function (e) { if (e.target === searchModal) closeSearch(); });

  if (searchField && psResults) {
    searchField.addEventListener('input', function () {
      clearTimeout(psTimer);
      var q = searchField.value.trim();
      if (q.length < 2) { psResults.innerHTML = ''; return; }
      psTimer = setTimeout(function () {
        if (psCtrl && psCtrl.abort) psCtrl.abort();
        psCtrl = window.AbortController ? new AbortController() : null;
        var url = R.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
        fetch(url, psCtrl ? { signal: psCtrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = (data && data.resources && data.resources.results) || {};
            var prods = res.products || [], cols = res.collections || [];
            if (!prods.length && !cols.length) {
              psResults.innerHTML = '<p class="ps-empty">Ingen treff på «' + esc(q) + '». Prøv merke, plaggtype eller størrelse.</p>';
              return;
            }
            var html = '';
            if (cols.length) {
              html += '<div class="ps-cols">' + cols.slice(0, 4).map(function (c) { return '<a class="ps-col" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
            }
            html += '<ul class="ps-list">' + prods.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              return '<li><a class="ps-item' + (p.available ? '' : ' ps-item--soldout') + '" href="' + esc(p.url) + '">' +
                (img ? '<img src="' + esc(imgSize(img, 120)) + '" alt="" loading="lazy" width="48" height="64">' : '<span class="ps-noimg"></span>') +
                '<span class="ps-meta"><span class="ps-vendor">' + esc(brand(p.vendor)) + '</span><span class="ps-title">' + esc(p.title) + '</span></span>' +
                '<span class="ps-price">' + (p.available ? money(Math.round(parseFloat(p.price) * 100)) : 'Solgt') + '</span></a></li>';
            }).join('') + '</ul>';
            html += '<button type="submit" form="search-form" class="ps-all">Se alle resultater for «' + esc(q) + '» →</button>';
            psResults.innerHTML = html;
          })
          .catch(function () {});
      }, 220);
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeNav(); closeSearch(); closeCart(); closeSidebar(); } });

  /* ─── HERO SLIDESHOW ─── */
  var heroSlides = document.querySelectorAll('.hero-slide');
  var heroPipNav = $('hero-nav');
  var current = 0, heroTimer;
  var interval = window.__heroInterval || 3000;
  var heroPips = [];
  if (heroPipNav && heroSlides.length > 1) {
    heroSlides.forEach(function (_, i) {
      var pip = document.createElement('button');
      pip.className = 'hero-pip' + (i === 0 ? ' is-active' : '');
      pip.setAttribute('aria-label', 'Bilde ' + (i + 1));
      pip.addEventListener('click', function () { clearInterval(heroTimer); goTo(i); startTimer(); });
      heroPipNav.appendChild(pip);
      heroPips.push(pip);
    });
  }
  function goTo(n) {
    if (!heroSlides.length) return;
    heroSlides[current].classList.remove('is-active');
    if (heroPips[current]) heroPips[current].classList.remove('is-active');
    current = (n + heroSlides.length) % heroSlides.length;
    heroSlides[current].classList.add('is-active');
    if (heroPips[current]) heroPips[current].classList.add('is-active');
  }
  function startTimer() { if (heroSlides.length > 1) heroTimer = setInterval(function () { goTo(current + 1); }, interval); }
  startTimer();

  /* ═══════════════════════ CART ═══════════════════════ */
  var cartDrawer = $('cart-drawer'), drawerOverlay = $('drawer-overlay'), cdClose = $('cd-close');
  var cdItems = $('cd-items'), cdFoot = $('cd-foot'), cdEmpty = $('cd-empty'), cdTotal = $('cd-total');
  var cdProgress = $('cd-progress'), cdRecs = $('cd-recs'), cdDiscounts = $('cd-discounts'), cdCount = $('cd-count');
  var lastCart = null;

  function openCart() {
    if (!cartDrawer) { window.location.href = R.cart; return; }
    fetchCart();
    cartDrawer.classList.add('open'); cartDrawer.setAttribute('aria-hidden', 'false');
    drawerOverlay && drawerOverlay.classList.add('open'); lockScroll(true);
    setTimeout(function () { cdClose && cdClose.focus(); }, 50);
  }
  function closeCart() {
    if (!cartDrawer || !cartDrawer.classList.contains('open')) return;
    cartDrawer.classList.remove('open'); cartDrawer.setAttribute('aria-hidden', 'true');
    drawerOverlay && drawerOverlay.classList.remove('open'); lockScroll(false);
  }
  window.SaksenCart = { open: openCart, close: closeCart, refresh: fetchCart };

  document.addEventListener('click', function (e) {
    var ci = e.target.closest('#cart-icon, .js-open-cart');
    if (ci && document.body.classList.contains('template-cart') === false) { e.preventDefault(); openCart(); }
  });
  if (cdClose) cdClose.addEventListener('click', closeCart);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeCart);

  function fetchCart() {
    return fetch(rootUrl + '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }

  function updateBadge(n) {
    document.querySelectorAll('#cart-badge, .js-cart-count').forEach(function (b) { b.textContent = n > 0 ? n : ''; });
  }

  function progressHtml(cart) {
    var html = '';
    var count = cart.item_count;
    if (T.bundle && T.bundle.enabled && T.bundle.qty > 1) {
      var need = T.bundle.qty - count;
      var pct = Math.min(100, Math.round(count / T.bundle.qty * 100));
      html += '<div class="cd-prog">' +
        '<p class="cd-prog-text">' + (need > 0
          ? 'Legg til <strong>' + need + ' plagg til</strong> og få <strong>' + esc(T.bundle.pct) + ' rabatt</strong> på hele ordren'
          : '🎉 Du har låst opp <strong>' + esc(T.bundle.pct) + ' rabatt</strong> – trekkes automatisk i kassen') + '</p>' +
        '<div class="cd-prog-bar"><span style="width:' + pct + '%"></span></div></div>';
    }
    if (T.freeShipping > 0) {
      var left = T.freeShipping - cart.total_price;
      var p2 = Math.min(100, Math.round(cart.total_price / T.freeShipping * 100));
      html += '<div class="cd-prog">' +
        '<p class="cd-prog-text">' + (left > 0 ? 'Du er <strong>' + money(left) + '</strong> unna gratis frakt' : '✓ Du har <strong>gratis frakt</strong>') + '</p>' +
        '<div class="cd-prog-bar"><span style="width:' + p2 + '%"></span></div></div>';
    }
    return html;
  }

  function renderCart(cart) {
    lastCart = cart;
    updateBadge(cart.item_count);
    if (cdCount) cdCount.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    if (!cdItems) return;
    cdItems.innerHTML = '';
    if (cdProgress) cdProgress.innerHTML = cart.item_count > 0 ? progressHtml(cart) : '';
    if (cart.item_count === 0) {
      if (cdFoot) cdFoot.style.display = 'none';
      if (cdEmpty) cdEmpty.style.display = 'flex';
      if (cdRecs) cdRecs.innerHTML = '';
      return;
    }
    if (cdFoot) cdFoot.style.display = 'flex';
    if (cdEmpty) cdEmpty.style.display = 'none';
    if (cdTotal) cdTotal.textContent = money(cart.total_price);

    if (cdDiscounts) {
      var titles = [];
      (cart.items || []).forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (a) {
          var t = a.discount_application && a.discount_application.title;
          if (t && titles.indexOf(t) === -1) titles.push(t);
        });
      });
      (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.title && titles.indexOf(a.title) === -1) titles.push(a.title); });
      cdDiscounts.innerHTML = cart.total_discount > 0
        ? '<div class="cd-subtotal cd-discount"><span>' + esc(titles.join(', ') || 'Rabatt') + '</span><span>−' + money(cart.total_discount) + '</span></div>'
        : '';
    }

    cart.items.forEach(function (item) {
      var el = document.createElement('div');
      el.className = 'cd-item';
      var img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var was = item.original_line_price > item.final_line_price ? '<s class="cd-was">' + money(item.original_line_price) + '</s> ' : '';
      el.innerHTML =
        '<a href="' + esc(item.url) + '" class="cd-img-link"><img class="cd-img" src="' + esc(imgSize(img, 200)) + '" alt="' + esc(item.product_title) + '" loading="lazy" width="80" height="100"></a>' +
        '<div class="cd-dets">' +
          '<p class="cd-vendor">' + esc(brand(item.vendor)) + '</p>' +
          '<a href="' + esc(item.url) + '" class="cd-name">' + esc(item.product_title) + '</a>' +
          (variant ? '<p class="cd-var">' + esc(variant) + '</p>' : '') +
          '<div class="cd-row">' +
            '<span class="cd-price">' + was + money(item.final_line_price) + '</span>' +
            '<div class="cd-qty">' +
              '<button type="button" data-key="' + esc(item.key) + '" data-q="' + (item.quantity - 1) + '" aria-label="Reduser antall">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-key="' + esc(item.key) + '" data-q="' + (item.quantity + 1) + '" aria-label="Øk antall">+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cd-remove" data-key="' + esc(item.key) + '" data-q="0">Fjern</button>' +
        '</div>';
      cdItems.appendChild(el);
    });
    cdItems.querySelectorAll('.cd-qty button, .cd-remove').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(btn.dataset.key, parseInt(btn.dataset.q, 10), btn); });
    });
    loadCartRecs(cart);
  }

  var recsFor = null;
  function loadCartRecs(cart) {
    if (!cdRecs || !T.cartRecommendations || !cart.items.length) { if (cdRecs) cdRecs.innerHTML = ''; return; }
    var pid = cart.items[0].product_id;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    if (recsFor === pid + ':' + inCart.join(',')) return;
    recsFor = pid + ':' + inCart.join(',');
    fetch(R.recs + '.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = (data.products || []).filter(function (p) { return p.available && inCart.indexOf(p.id) === -1; }).slice(0, 4);
        if (!list.length) { cdRecs.innerHTML = ''; return; }
        var need = T.bundle && T.bundle.enabled ? T.bundle.qty - cart.item_count : 0;
        cdRecs.innerHTML = '<p class="cd-recs-title">' + (need > 0 ? 'Fullfør looken – ' + need + ' til gir ' + esc(T.bundle.pct) + ' rabatt' : 'Fullfør looken') + '</p>' +
          '<div class="cd-recs-row">' + list.map(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; });
            var one = v.length === 1 ? v[0] : null;
            var img = p.featured_image || (p.images && p.images[0]) || '';
            return '<div class="cd-rec">' +
              '<a href="' + esc(p.url) + '"><img src="' + esc(imgSize(img, 240)) + '" alt="' + esc(p.title) + '" loading="lazy" width="120" height="160"></a>' +
              '<p class="cd-rec-title">' + esc(p.title) + '</p>' +
              '<p class="cd-rec-price">' + money(p.price) + (one && one.title !== 'Default Title' ? ' · ' + esc(one.title) : '') + '</p>' +
              (one ? '<button type="button" class="cd-rec-add js-quick-add" data-vid="' + one.id + '">+ Legg til</button>'
                   : '<a class="cd-rec-add" href="' + esc(p.url) + '">Velg størrelse</a>') +
              '</div>';
          }).join('') + '</div>';
      })
      .catch(function () { cdRecs.innerHTML = ''; });
  }

  function changeQty(key, qty, btn) {
    if (btn) btn.disabled = true;
    fetch(R.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) { toast(T.strings.onlyOne || 'Ikke flere på lager'); return fetchCart(); }
        var c = res.body;
        // Unike plagg: Shopify kan kutte antallet stille – gi beskjed
        var line = (c.items || []).filter(function (i) { return i.key === key; })[0];
        if (line && qty > line.quantity) toast(T.strings.onlyOne || 'Ikke flere på lager');
        renderCart(c);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
      })
      .catch(function () { toast('Noe gikk galt – prøv igjen'); fetchCart(); });
  }

  function setBtnState(btn, state) {
    if (!btn) return;
    if (state === 'loading') { btn.dataset.orig = btn.innerHTML; btn.disabled = true; btn.classList.add('is-loading'); }
    else { btn.disabled = false; btn.classList.remove('is-loading'); if (btn.dataset.orig) btn.innerHTML = btn.dataset.orig; }
    if (state === 'done') {
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
    }
  }

  function addToCart(vid, qty, btn, opts) {
    opts = opts || {};
    setBtnState(btn, 'loading');
    return fetch(R.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = res.body && (res.body.description || res.body.message);
          if (msg && /already|allerede|all \d+|alle/i.test(msg)) msg = T.strings.onlyOne;
          throw new Error(msg || T.strings.addError);
        }
        setBtnState(btn, 'done');
        if (opts.checkout) { window.location.href = rootUrl + '/checkout'; return; }
        return fetchCart().then(function (c) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
          if (cartDrawer) openCart(); else toast(T.strings.added || 'Lagt i handlekurven');
        });
      })
      .catch(function (err) { setBtnState(btn, 'idle'); toast(err && err.message ? err.message : (T.strings.addError || 'Kunne ikke legge til')); });
  }
  window.SaksenCart.add = addToCart;

  /* ─── QUICK-ADD (produktkort, handlekurv-forslag) ─── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-quick-add, .pcard-atc, .col-atc-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || !btn.dataset.vid) return;
    addToCart(btn.dataset.vid, 1, btn);
  });

  /* ═══════════════════════ PRODUCT PAGE ═══════════════════════ */
  var ppForm = $('pp-form');
  if (ppForm) {
    var product = window.__product || null;
    var vs = $('pp-variant');
    var atc = $('pp-atc'), atcTxt = $('pp-atc-text');
    var sticky = $('pp-sticky'), stickyBtn = $('pp-sticky-btn'), stickyPrice = $('pp-sticky-price'), stickyVar = $('pp-sticky-variant');

    function selectedOptions() {
      var sel = [];
      ppForm.querySelectorAll('.pp-opt-boxes').forEach(function (g) {
        var s = g.querySelector('.pp-opt-box--sel');
        sel.push(s ? s.dataset.val : null);
      });
      return sel;
    }

    function markAvailability() {
      if (!product) return;
      var sel = selectedOptions();
      ppForm.querySelectorAll('.pp-opt-boxes').forEach(function (g, gi) {
        g.querySelectorAll('.pp-opt-box').forEach(function (b) {
          var test = sel.slice(); test[gi] = b.dataset.val;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return test[i] == null || o === test[i]; });
          });
          b.classList.toggle('pp-opt-box--na', !ok);
        });
      });
    }

    function applyVariant(match) {
      if (!match) {
        if (atc) atc.disabled = true;
        if (atcTxt) atcTxt.textContent = 'IKKE TILGJENGELIG';
        return;
      }
      if (vs) vs.value = match.id;
      var pp = $('pp-price');
      if (pp) {
        pp.innerHTML = (match.compare_at_price > match.price ? '<s class="pp-price-old">' + money(match.compare_at_price) + '</s>' : '') +
          '<span class="pp-price-gold">' + money(match.price) + '</span>' +
          (match.compare_at_price > match.price ? '<span class="pp-price-save">— du sparer ' + money(match.compare_at_price - match.price) + '</span>' : '');
      }
      if (atc) atc.disabled = !match.available;
      if (atcTxt) atcTxt.textContent = match.available ? 'LEGG I HANDLEKURV' : 'SOLGT';
      if (stickyBtn) { stickyBtn.disabled = !match.available; stickyBtn.textContent = match.available ? 'LEGG I KURV' : 'UTSOLGT'; }
      if (stickyPrice) stickyPrice.textContent = money(match.price);
      if (stickyVar) stickyVar.textContent = match.title !== 'Default Title' ? match.title : '';
      var dyn = ppForm.querySelector('.shopify-payment-button');
      if (dyn) dyn.style.display = match.available ? '' : 'none';
      if (match.featured_media && match.featured_media.id) showMedia(String(match.featured_media.id));
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u.toString());
      }
    }

    ppForm.querySelectorAll('.pp-opt-box').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.dataset.oi;
        ppForm.querySelectorAll('.pp-opt-box[data-oi="' + idx + '"]').forEach(function (b) { b.classList.remove('pp-opt-box--sel'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('pp-opt-box--sel'); btn.setAttribute('aria-pressed', 'true');
        var lbl = document.querySelector('.js-opt-selected[data-oi="' + idx + '"]'); if (lbl) lbl.textContent = btn.dataset.val;
        if (!product) return;
        var sel = selectedOptions();
        var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
        applyVariant(match);
        markAvailability();
      });
    });
    markAvailability();

    ppForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var vid = vs ? vs.value : null;
      if (!vid) return;
      addToCart(vid, 1, atc);
    });
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (vs && vs.value) addToCart(vs.value, 1, stickyBtn);
    });

    // Sticky kjøpsknapp vises når hovedknappen er ute av syne
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(atc);
    }

    /* Galleri: bilder + video */
    var mainWrap = $('pp-media-main');
    function showMedia(id) {
      if (!mainWrap) return;
      var items = mainWrap.querySelectorAll('.pp-media-item');
      var found = false;
      items.forEach(function (m) {
        var on = m.dataset.mediaId === id;
        if (on) found = true;
        m.classList.toggle('is-active', on);
        if (!on) { var v = m.querySelector('video'); if (v) v.pause(); }
        else { var v2 = m.querySelector('video'); if (v2) { v2.muted = true; v2.play().catch(function () {}); } }
      });
      if (!found) return;
      document.querySelectorAll('.pp-thumb').forEach(function (x) { x.classList.toggle('active', x.dataset.mediaId === id); });
    }
    document.querySelectorAll('.pp-thumb').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.mediaId); });
    });
    // Sveip på mobil
    if (mainWrap) {
      var sx = null;
      mainWrap.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) < 40) return;
        var items = Array.prototype.slice.call(mainWrap.querySelectorAll('.pp-media-item'));
        var i = items.findIndex(function (m) { return m.classList.contains('is-active'); });
        var n = (i + (dx < 0 ? 1 : -1) + items.length) % items.length;
        showMedia(items[n].dataset.mediaId);
      });
    }
  }

  /* ─── FEATURED PRODUCT ─── */
  var fpForm = $('fp-form');
  if (fpForm) {
    fpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = fpForm.querySelector('[name="id"]');
      if (inp) addToCart(inp.value, 1, fpForm.querySelector('[type="submit"]'));
    });
    document.querySelectorAll('.fp-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = $('fp-main-img'); if (main) main.src = t.dataset.src;
        document.querySelectorAll('.fp-thumb').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  /* ─── PRODUCT RECOMMENDATIONS (seksjon) ─── */
  document.querySelectorAll('[data-recs-url]').forEach(function (el) {
    fetch(el.dataset.recsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recs-grid]');
        if (fresh && fresh.children.length) {
          var grid = el.querySelector('[data-recs-grid]');
          if (grid) grid.innerHTML = fresh.innerHTML;
          el.hidden = false;
        }
      }).catch(function () {});
  });

  /* ─── FAQ ─── */
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var ans = item.querySelector('.faq-a');
      var inner = item.querySelector('.faq-a-inner');
      var open = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
        var a = i.querySelector('.faq-a'); if (a) a.style.maxHeight = '0';
        var q = i.querySelector('.faq-q'); if (q) q.setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        if (ans && inner) ans.style.maxHeight = (inner.scrollHeight + 32) + 'px';
      }
    });
  });

  /* ═══════════════════════ COLLECTION ═══════════════════════ */
  function colSidebar() { return document.querySelector('.col-sidebar'); }
  function openSidebar() { var s = colSidebar(), o = $('col-sidebar-overlay'); s && s.classList.add('open'); o && o.classList.add('open'); lockScroll(true); }
  function closeSidebar() { var s = colSidebar(), o = $('col-sidebar-overlay'); if (!s || !s.classList.contains('open')) return; s.classList.remove('open'); o && o.classList.remove('open'); lockScroll(false); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('#col-filter-toggle')) { openSidebar(); return; }
    if (e.target.closest('#col-sidebar-close, #col-sidebar-overlay, #col-sidebar-apply')) { closeSidebar(); }
  });

  /* Størrelser: gjør «Small», «S-M», «L-XL», «XXS-XS», «Str. M» osv. sammenlignbare */
  var SIZE_MAP = {
    'xxs': 'XXS', 'xx-small': 'XXS', 'xxsmall': 'XXS',
    'xs': 'XS', 'x-small': 'XS', 'xsmall': 'XS', 'extra small': 'XS', 'extra-small': 'XS',
    's': 'S', 'small': 'S', 'sm': 'S',
    'm': 'M', 'medium': 'M', 'med': 'M',
    'l': 'L', 'large': 'L', 'lg': 'L',
    'xl': 'XL', 'x-large': 'XL', 'xlarge': 'XL', 'extra large': 'XL', 'extra-large': 'XL',
    'xxl': 'XXL', '2xl': 'XXL', 'xx-large': 'XXL', 'xxlarge': 'XXL',
    'xxxl': 'XXXL', '3xl': 'XXXL', 'xxx-large': 'XXXL'
  };
  function normSizes(raw) {
    var out = [];
    (raw || '').split('|').forEach(function (val) {
      var v = val.toLowerCase().replace(/str\.?|størrelse|size/g, '').trim();
      if (!v) return;
      if (SIZE_MAP[v]) { out.push(SIZE_MAP[v]); return; }
      v.split(/[\s\/\-–,()]+/).forEach(function (tok) {
        tok = tok.replace(/[^a-z0-9]/g, '');
        if (!tok) return;
        out.push(SIZE_MAP[tok] || tok.toUpperCase());
      });
    });
    return out;
  }

  // mode: 'all' = tilgjengelige først, solgte nederst med «SOLGT» (standard) · 'available' = skjul solgte
  var colState = { size: 'all', mode: 'available', loadingAll: false };

  function applyClientFilters() {
    var grid = $('col-pgrid'); if (!grid) return;
    var cards = grid.querySelectorAll('.col-pcard');
    var shown = 0, shownAvail = 0;
    cards.forEach(function (card) {
      var avail = card.getAttribute('data-available') === 'true';
      var modeOk = colState.mode === 'all' ? true : avail;
      var raw = avail ? (card.getAttribute('data-sizes-available') || card.getAttribute('data-sizes')) : card.getAttribute('data-sizes');
      var sizeOk = colState.size === 'all' || normSizes(raw).indexOf(colState.size) !== -1;
      var ok = modeOk && sizeOk;
      card.style.display = ok ? '' : 'none';
      if (ok) { shown++; if (avail) shownAvail++; }
    });
    var cnt = $('col-count');
    var more = document.querySelector('.js-load-more');
    if (cnt) {
      var sold = shown - shownAvail;
      if (grid.classList.contains('sold-grid')) cnt.textContent = '';
      else cnt.textContent = (colState.loadingAll ? 'Laster … ' : '') + shownAvail + ' plagg til salgs' + (colState.size !== 'all' ? ' i ' + colState.size : '');
    }
    var empty = $('col-empty'); if (empty) empty.hidden = shown > 0 || !!more;
  }

  function loadNextPage(btn) {
    var url = btn.dataset.nextUrl; if (!url) return Promise.resolve(false);
    btn.disabled = true; btn.textContent = 'LASTER …';
    var sid = currentSectionId();
    var fetchUrl = sid ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid) : url;
    return fetch(fetchUrl).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = $('col-pgrid');
      var newCards = doc.querySelectorAll('#col-pgrid .col-pcard');
      // Tilgjengelige plagg settes før de solgte som allerede ligger i gridet
      var firstSold = grid.querySelector('.col-pcard[data-available="false"]');
      newCards.forEach(function (c) {
        var node = document.importNode(c, true);
        if (node.getAttribute('data-available') === 'true' && firstSold) grid.insertBefore(node, firstSold);
        else grid.appendChild(node);
      });
      var nextBtn = doc.querySelector('.js-load-more');
      if (nextBtn) { btn.dataset.nextUrl = nextBtn.dataset.nextUrl; btn.disabled = false; btn.textContent = 'VIS FLERE PLAGG'; }
      else { var w = btn.closest('.col-loadmore-wrap'); if (w) w.remove(); }
      applyClientFilters();
      return !!nextBtn;
    }).catch(function () { btn.disabled = false; btn.textContent = 'VIS FLERE PLAGG'; return false; });
  }

  // Når et hurtigfilter er aktivt lastes alle sider, så resultatet blir komplett
  function loadAllPages() {
    if (colState.loadingAll) return;
    var btn = document.querySelector('.js-load-more');
    if (!btn) return;
    colState.loadingAll = true;
    var guard = 0;
    (function step() {
      var b = document.querySelector('.js-load-more');
      if (!b || guard++ > 15) { colState.loadingAll = false; applyClientFilters(); return; }
      loadNextPage(b).then(function (hasMore) { if (hasMore) step(); else { colState.loadingAll = false; applyClientFilters(); } });
    })();
  }

  document.addEventListener('click', function (e) {
    var lm = e.target.closest('.js-load-more');
    if (lm) { e.preventDefault(); loadNextPage(lm); return; }

    var sb = e.target.closest('#size-filter-btns .col-size-btn');
    if (sb) {
      colState.size = sb.getAttribute('data-size');
      document.querySelectorAll('#size-filter-btns .col-size-btn').forEach(function (b) { b.classList.remove('col-size-btn--active'); b.setAttribute('aria-pressed', 'false'); });
      sb.classList.add('col-size-btn--active'); sb.setAttribute('aria-pressed', 'true');
      applyClientFilters();
      if (colState.size !== 'all') loadAllPages();
      return;
    }

    var sold = e.target.closest('#col-sold-btn');
    if (sold) {
      var hint = $('col-sold-hint');
      var hide = colState.mode === 'all';
      colState.mode = hide ? 'available' : 'all';
      sold.classList.toggle('col-sold-btn--active', hide); sold.setAttribute('aria-pressed', hide ? 'true' : 'false');
      if (hint) hint.textContent = hide ? 'Viser kun tilgjengelige plagg' : 'Solgte plagg vises nederst';
      sold.querySelector('.col-sold-label').textContent = hide ? 'Vis solgte plagg' : 'Skjul solgte plagg';
      applyClientFilters();
      return;
    }

    var fl = e.target.closest('.js-filter-link');
    if (fl) { e.preventDefault(); renderCollection(fl.href); }
  });

  /* Native filtre + sortering – oppdateres uten full sideinnlasting */
  function currentSectionId() { var c = document.querySelector('.colpage[data-section-id]'); return c ? c.dataset.sectionId : null; }

  function renderCollection(url) {
    var sid = currentSectionId();
    var sidebarWasOpen = colSidebar() && colSidebar().classList.contains('open');
    if (!sid) { window.location.href = url; return; }
    var grid = $('col-pgrid'); if (grid) grid.classList.add('is-loading');
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
    fetch(fetchUrl).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.colpage');
      var old = document.querySelector('.colpage');
      if (!fresh || !old) throw 0;
      old.replaceWith(fresh);
      history.pushState({ col: true }, '', url);
      colState.size = 'all';
      initCollection();
      if (sidebarWasOpen) { var s = colSidebar(); s && s.classList.add('open'); }
    }).catch(function () { window.location.href = url; });
  }

  function buildFilterUrl() {
    var form = $('col-filter-form'); if (!form) return null;
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '' && v != null) params.append(k, v); });
    var sort = $('col-sort'); if (sort) { params.delete('sort_by'); params.set('sort_by', sort.value); }
    var qs = params.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('.js-filter-input')) {
      var lab = e.target.closest('label'); if (lab) lab.classList.toggle('is-active', e.target.checked);
      renderCollection(buildFilterUrl());
    } else if (e.target.id === 'col-sort') {
      var u = buildFilterUrl();
      if (u) renderCollection(u); else window.location.search = '?sort_by=' + encodeURIComponent(e.target.value);
    }
  });
  document.addEventListener('submit', function (e) {
    if (e.target.id === 'col-filter-form') { e.preventDefault(); renderCollection(buildFilterUrl()); }
  });
  window.addEventListener('popstate', function (e) { if (e.state && e.state.col) window.location.reload(); });

  function initCollection() {
    var grid = $('col-pgrid');
    if (!grid) return;
    if (grid.classList.contains('sold-grid')) { colState.mode = 'all'; return; }
    colState.mode = 'available';
    applyClientFilters();
    // Solgte plagg vises ikke i vanlige kolleksjoner → hent resten av sidene automatisk,
    // så alle plagg til salgs vises (uavhengig av hvor de ligger i sorteringen).
    loadAllPages();
  }
  initCollection();

  /* ─── SHOPPABLE VIDEO (hjemmeside) ─── */
  document.querySelectorAll('.sv-card video').forEach(function (v) {
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
    }, { threshold: 0.5 }).observe(v);
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.sv-sound');
    if (!t) return;
    var v = t.closest('.sv-card').querySelector('video');
    if (!v) return;
    v.muted = !v.muted; t.textContent = v.muted ? '🔇' : '🔊';
    t.setAttribute('aria-label', v.muted ? 'Slå på lyd' : 'Slå av lyd');
  });

  /* ─── HEADER SHADOW ─── */
  var hdr = $('header');
  window.addEventListener('scroll', function () {
    if (hdr) hdr.style.boxShadow = window.scrollY > 50 ? '0 4px 32px rgba(0,0,0,0.6)' : 'none';
  }, { passive: true });

  /* Oppdater badge ved sideinnlasting fra bfcache */
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart(); });
})();
